export default __webpack_public_path__ + "static/media/menu-community.e69b08a8.jpg";